import React from 'react'
import { Flex } from '@mantine/core'
import { SortableWidgetChildren } from '../SortableComponents'
import { ContainerWrapper } from '../ContainerWrapper'
import { useWidgetEditor } from '../state'
import { ContainerForm } from '../ContainerForm'
import cls from './common.module.css'
import { ContainerOptions } from '../schemas'

export default function Container({ id }: { id: string }) {
  const editor = useWidgetEditor()
  const config = editor.useConfig(id)

  if (config.widget !== 'Container')
    throw new Error('Invalid widget type, expected Container')

  return (
    <ContainerWrapper
      name="Container"
      id={id}
      onCancel={editor.endEditWidget}
      onSave={editor.save}
    >
      <Flex
        gap={8}
        direction={config.options.direction === 'horizontal' ? 'row' : 'column'}
        className={
          config.options.direction === 'horizontal' ? cls.flexFill : ''
        }
      >
        <SortableWidgetChildren id={id} dir="horizontal" />
      </Flex>
    </ContainerWrapper>
  )
}

export const ContainerRegistry = {
  component: Container,
  formComponent: ContainerForm,
  mock: () => null,
  getInitialOptions: () => ContainerOptions.parse({}),
}
